import {observable} from 'mobx';
import {Language} from './language';
import {OfferPage} from './offer-page';
import {OfferLocaleKey} from './offer-locale-key';
import {construct, createInstance, ModelProperties} from '../utils';

export class OfferLocaleContent {
    @observable id!: number;

    @observable contentEdited!: string;

    @observable contentVerified!: string;

    @observable verified!: boolean;

    @observable keyId!: number;

    @observable pageId!: number;

    @observable languageId!: number;

    @observable key?: OfferLocaleKey;

    @observable page?: OfferPage;

    @observable language?: Language;

    constructor(content?: ModelProperties<OfferLocaleContent>) {
        if (content) {
            construct(this, content);
            this.key = createInstance(OfferLocaleKey, content.key);
            this.page = createInstance(OfferPage, content.page);
            this.language = createInstance(Language, content.language);
        }
    }

}
